// See ./wdyr.ts for readme
// import './wdyr'
import React from 'react'
import ReactDOM from 'react-dom'
import { Locale } from '@ocean/configs/dist'
import { initLocalization } from 'config/localization/i18n'
import en from 'assets/locales/en/translation.json'
import Root from './Root'
import * as serviceWorker from './serviceWorker'

initLocalization(Locale.En, en)

const render = (RootComponent: any) =>
  ReactDOM.render(React.createElement(RootComponent), document.getElementById('app-root'))

render(Root)

if (module.hot) {
  module.hot.accept('./Root', () => {
    const NextApp = require('./Root').default
    render(NextApp)
  })
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
